const initialState = () => ({
  limitedModeDetails: undefined,
  liveState: undefined,
  modals: {
    sessionEnded: {
      open: false
    },
    sessionStarted: {
      open: false
    }
  },
  previousFetcherAlias: undefined,
  sessions: undefined,
  sessionDetails: undefined
});

const terratalkLiveState = initialState();

export { terratalkLiveState };
